module.exports = __webpack_public_path__ + "static/langojango-khmer-language-phrasebook-9b59d6935e6c771ba7584b7d889e5031.png";